import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../Utils/helper';
import { CarouselImageDiv } from '../../IVF/IVFCarousel/styled';
import { categoryStaticData, fireClickedCardEvent } from '../staticData';
import OvulationCategoriesInner from './OvulationCategoriesInner';
import { CategoryContainer, OvulationBannerCategory } from './styled';

function OvulationCategories(props) {
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState();
  const bannerOnClick = () => {
    fireClickedCardEvent(
      '',
      'Empower your fertility journey',
      '/category/fertility-7005',
    );
    setClickEffect('lowOpacity');
    setTimeout(() => {
      setClickEffect('');
    }, 200);
  };

  return (
    <OvulationBannerCategory>
      <div onClick={bannerOnClick} className={`doctorImg ${clickEffect}`}>
        <Link
          href={{
            pathname: '/category/fertility-7005',
            query: removeDefaultParams(router.query),
          }}
          locale={false}
          passHref
          legacyBehavior
        >
          <CarouselImageDiv as="a">
            <Image
              className="carousel-mobile"
              src={images.ovulation_banner}
              quality={90}
              alt=""
              fill
              sizes="100vw"
            />
            <Image
              className="carousel-desktop"
              src={images.ovulation_banner_desktop}
              quality={90}
              alt=""
              fill
              sizes="100vw"
            />
          </CarouselImageDiv>
        </Link>
      </div>
      <CategoryContainer>
        {categoryStaticData?.map((element, index) => {
          return (
            <OvulationCategoriesInner key={`cate_${index}`} element={element} />
          );
        })}
      </CategoryContainer>
    </OvulationBannerCategory>
  );
}

export default OvulationCategories;
